export const DEFAULT_ONBOARDING_COUNTRIES = ['US', 'JP', 'BR', 'MX', 'PK', 'TH', 'ID']
export const ONBOARDING_COUNTRIES_STORAGE_KEY = 'onboardingFunnel.visibleCountries.v1'

export const ONBOARDING_COUNTRY_CODES = (
    'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
    'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP ' +
    'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ ' +
    'NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW ' +
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ ' +
    'UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'
).split(' ')

export const readOnboardingCountryPreferences = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(ONBOARDING_COUNTRIES_STORAGE_KEY))
        if (Array.isArray(stored) && stored.every(code => ONBOARDING_COUNTRY_CODES.includes(code))) {
            return [...new Set(stored)]
        }
    } catch (_error) {
        // 브라우저 저장소를 사용할 수 없어도 기본 필터로 조회할 수 있다.
    }
    return [...DEFAULT_ONBOARDING_COUNTRIES]
}

export const saveOnboardingCountryPreferences = (countries) => {
    try {
        localStorage.setItem(ONBOARDING_COUNTRIES_STORAGE_KEY, JSON.stringify(countries))
        return true
    } catch (_error) {
        return false
    }
}
